<template>
  <g>
    <rect :width="width" :height="height" fill="none" />
    <text text-anchor="middle" fill="black" xml:space="preserve" style="white-space: pre" font-weight="bold" font-family="Poppins, Helvetica neue, Helvetica" font-size="18" letter-spacing="0em">
        <tspan :x="width/2" y="1em">TOP BEHAVIOURS</tspan>
    </text>

    <bar-graph-item :item="b" :height="barHeight" :width="barWidth" v-for="(b,i) in chart" :key="i" :x="(barWidth + margin) * i" :y="top" />

  </g>
</template>

<script>
import * as R from 'ramda'
import BarGraphItem from './BarGraphItem'
export default {
  components:{
    BarGraphItem,
  },
  props:{
    behaviours: {
      type: Array,
      default: () => []
    }
  },
  data(){
    return {
      total: 5,
      width: 626,
      height: 195,
      top: 35,
      margin: 20,
    }
  },
  computed:{
    highestPoint(){
      return R.pipe(
        R.sortBy(R.prop('value')),
        R.last,
        R.prop('value')
      )(this.behaviours)
    },
    highestScan(){
      return R.pipe(
        R.sortBy(R.prop('totalScan')),
        R.last,
        R.prop('totalScan')
      )(this.behaviours)
    },
    chart(){
      return R.take(this.total,this.behaviours).map( b => ({
        label: b.name,
        point: b.value,
        scan: b.totalScan,
        pointScale: b.value / this.highestPoint,
        scanScale: b.totalScan / this.highestPoint,
      }))
    },
    barWidth(){
      return (this.width - ((this.total-1) * this.margin)) / this.total
    },
    barHeight(){
      return this.height - this.top;
    }
  }
}
</script>